(function () {
  var TARGET_CLASS = "wl-mui-fadein";
  var ACTIVE_CLASS = "wl-mui-fadein--active";
  var READY_CLASS = "wl-mui-fadein--ready";

  function supportsReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function setInitialStyle(el) {
    el.style.opacity = "0";
    el.style.transform = "translate3d(0px, 2rem, 0px) scale(1.02)";
    el.style.willChange = "opacity, transform";
    el.style.transition =
      "opacity 1000ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms, transform 1000ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms";
  }

  function setActiveStyle(el) {
    el.style.opacity = "1";
    el.style.transform = "translate3d(0px, 0px, 0px) scale(1)";
    el.style.transition =
      "opacity 1500ms cubic-bezier(0.25, 0.1, 0.25, 1) 60ms, transform 1620ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms";
  }

  function prepElement(el) {
    if (el.classList.contains(READY_CLASS)) return;
    setInitialStyle(el);
    el.classList.add(READY_CLASS);
  }

  function getOffsetTop(el) {
    var top = 0;
    var current = el;
    while (current && !isNaN(current.offsetTop)) {
      top += current.offsetTop;
      current = current.offsetParent;
    }
    return top;
  }

  function FadeinController(elements) {
    this.elements = elements || [];
    this.array = [];
    this.borderTop = 0;
    this.borderBottom = 0.8;
    this.windowTop = 0;
    this.windowBottom = 0;
    this.areaTop = 0;
    this.areaBottom = 0;
    this.remove = true;
    this.onScrollBound = this.onScroll.bind(this);
    this.onResizeBound = this.onResize.bind(this);
  }

  FadeinController.prototype.init = function () {
    if (!this.elements.length) return;

    this.windowTop = window.innerHeight * this.borderTop;
    this.windowBottom = window.innerHeight * this.borderBottom;
    this.array = [];

    for (var i = 0; i < this.elements.length; i++) {
      var el = this.elements[i];
      prepElement(el);
      this.array.push({
        el: el,
        top: getOffsetTop(el),
        height: el.offsetHeight,
      });
    }

    this.onScroll();
  };

  FadeinController.prototype.onScroll = function () {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    this.areaTop = Math.floor(scrollTop + this.windowTop);
    this.areaBottom = Math.floor(scrollTop + this.windowBottom);

    for (var i = 0; i < this.array.length; i++) {
      var item = this.array[i];
      var el = item.el;
      var top = item.top;
      var bottom = item.top + item.height;
      var isInRange = this.areaBottom >= top && this.areaTop <= bottom;

      if (isInRange) {
        if (!el.classList.contains(ACTIVE_CLASS)) {
          el.classList.add(ACTIVE_CLASS);
          setActiveStyle(el);
        }
      } else if (this.remove) {
        var shouldRemove = true;
        if (el.hasAttribute("data-remove")) {
          shouldRemove = String(el.getAttribute("data-remove")).toLowerCase() !== "false";
        }
        if (shouldRemove && el.classList.contains(ACTIVE_CLASS)) {
          el.classList.remove(ACTIVE_CLASS);
          setInitialStyle(el);
        }
      }
    }
  };

  FadeinController.prototype.onResize = function () {
    this.init();
  };

  FadeinController.prototype.bind = function () {
    if (!this.elements.length) return;
    window.addEventListener("scroll", this.onScrollBound, false);
    window.addEventListener("resize", this.onResizeBound, false);
  };

  function boot(root) {
    var scope = root || document;
    var targets = Array.prototype.slice.call(scope.getElementsByClassName(TARGET_CLASS));
    if (!targets.length) return null;

    if (supportsReducedMotion()) {
      for (var i = 0; i < targets.length; i++) {
        targets[i].style.opacity = "1";
        targets[i].style.transform = "none";
      }
      return null;
    }

    var controller = new FadeinController(targets);
    controller.init();
    controller.bind();
    return controller;
  }

  var controller = null;
  function initializeAll() {
    controller = boot(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAll, { once: true });
  } else {
    initializeAll();
  }

  var mutationObserver = new MutationObserver(function () {
    if (controller) return;
    controller = boot(document);
  });
  mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
